// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/invite/v1/invite.v1.proto (package no.jotta.openapi.invite.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFamilyInviteRequest
 */
export class GetFamilyInviteRequest extends Message {
    /**
     * @generated from field: string family_invite_id = 1;
     */
    familyInviteId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFamilyInviteRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "family_invite_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetFamilyInviteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFamilyInviteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFamilyInviteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFamilyInviteRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFamilyInviteResponse
 */
export class GetFamilyInviteResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.invite.v1.GetFamilyInviteResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFamilyInviteResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "not_found", kind: "message", T: GetFamilyInviteResponse_NotFound, oneof: "result" },
        { no: 2, name: "cancelled", kind: "message", T: GetFamilyInviteResponse_Cancelled, oneof: "result" },
        { no: 3, name: "accepted", kind: "message", T: GetFamilyInviteResponse_Accepted, oneof: "result" },
        { no: 4, name: "invite", kind: "message", T: GetFamilyInviteResponse_Invite, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new GetFamilyInviteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFamilyInviteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFamilyInviteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFamilyInviteResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFamilyInviteResponse.NotFound
 */
export class GetFamilyInviteResponse_NotFound extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFamilyInviteResponse.NotFound";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetFamilyInviteResponse_NotFound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFamilyInviteResponse_NotFound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFamilyInviteResponse_NotFound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFamilyInviteResponse_NotFound, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFamilyInviteResponse.Cancelled
 */
export class GetFamilyInviteResponse_Cancelled extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFamilyInviteResponse.Cancelled";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetFamilyInviteResponse_Cancelled().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFamilyInviteResponse_Cancelled().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFamilyInviteResponse_Cancelled().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFamilyInviteResponse_Cancelled, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFamilyInviteResponse.Accepted
 */
export class GetFamilyInviteResponse_Accepted extends Message {
    /**
     * @generated from field: bool by_current_user = 1;
     */
    byCurrentUser = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFamilyInviteResponse.Accepted";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "by_current_user", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetFamilyInviteResponse_Accepted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFamilyInviteResponse_Accepted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFamilyInviteResponse_Accepted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFamilyInviteResponse_Accepted, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFamilyInviteResponse.Invite
 */
export class GetFamilyInviteResponse_Invite extends Message {
    /**
     * @generated from field: string family_name = 1;
     */
    familyName = "";
    /**
     * @generated from field: string invitee_name = 2;
     */
    inviteeName = "";
    /**
     * @generated from field: string invitee_email = 3;
     */
    inviteeEmail = "";
    /**
     * @generated from field: optional string redirect_url = 4;
     */
    redirectUrl;
    /**
     * @generated from field: bool matches_existing_account = 5;
     */
    matchesExistingAccount = false;
    /**
     * @generated from field: bool from_current_user = 6;
     */
    fromCurrentUser = false;
    /**
     * @generated from field: string customer_group_code = 7;
     */
    customerGroupCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFamilyInviteResponse.Invite";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "family_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "invitee_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "invitee_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 5, name: "matches_existing_account", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 6, name: "from_current_user", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 7, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetFamilyInviteResponse_Invite().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFamilyInviteResponse_Invite().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFamilyInviteResponse_Invite().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFamilyInviteResponse_Invite, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFolderShareInviteRequest
 */
export class GetFolderShareInviteRequest extends Message {
    /**
     * @generated from field: string folder_share_invite_id = 1;
     */
    folderShareInviteId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFolderShareInviteRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "folder_share_invite_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetFolderShareInviteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFolderShareInviteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFolderShareInviteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFolderShareInviteRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFolderShareInviteResponse
 */
export class GetFolderShareInviteResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.invite.v1.GetFolderShareInviteResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFolderShareInviteResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "not_found", kind: "message", T: GetFolderShareInviteResponse_NotFound, oneof: "result" },
        { no: 2, name: "accepted", kind: "message", T: GetFolderShareInviteResponse_Accepted, oneof: "result" },
        { no: 3, name: "invite", kind: "message", T: GetFolderShareInviteResponse_Invite, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new GetFolderShareInviteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFolderShareInviteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFolderShareInviteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFolderShareInviteResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFolderShareInviteResponse.NotFound
 */
export class GetFolderShareInviteResponse_NotFound extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFolderShareInviteResponse.NotFound";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetFolderShareInviteResponse_NotFound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFolderShareInviteResponse_NotFound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFolderShareInviteResponse_NotFound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFolderShareInviteResponse_NotFound, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFolderShareInviteResponse.Accepted
 */
export class GetFolderShareInviteResponse_Accepted extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFolderShareInviteResponse.Accepted";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetFolderShareInviteResponse_Accepted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFolderShareInviteResponse_Accepted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFolderShareInviteResponse_Accepted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFolderShareInviteResponse_Accepted, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.invite.v1.GetFolderShareInviteResponse.Invite
 */
export class GetFolderShareInviteResponse_Invite extends Message {
    /**
     * @generated from field: string inviter_name = 1;
     */
    inviterName = "";
    /**
     * @generated from field: string invitee_email = 2;
     */
    inviteeEmail = "";
    /**
     * @generated from field: bool matches_existing_account = 3;
     */
    matchesExistingAccount = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.invite.v1.GetFolderShareInviteResponse.Invite";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inviter_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "invitee_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "matches_existing_account", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetFolderShareInviteResponse_Invite().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFolderShareInviteResponse_Invite().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFolderShareInviteResponse_Invite().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFolderShareInviteResponse_Invite, a, b);
    }
}
